import { LoadingButton } from '@mui/lab';

import type { LoadingButtonProps } from '@mui/lab';
import type { FC } from 'react';

export const SubmitButton: FC<LoadingButtonProps> = ({
  children = 'submit',
  ...props
}) => (
  <LoadingButton
    size="large"
    type="submit"
    variant="contained"
    {...props}
  >
    {children}
  </LoadingButton>
);
